import { useMutation, useQueryClient } from "react-query";
import axios, { AxiosError, AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { openingTimesUrls } from "../../URL/ApplicationUrls";
import { updateSuccessMessage } from "../../Messages/successMessages";
import { MdmApiError } from "../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";
import OpeningTime, { OpeningTimeDto } from "../../OpeningTimes/OpeningTime";
import { openingTimeWithIdQueryKey } from "../../OpeningTimes/openingTimeQueryKeys";
import { OpeningTimeMapper } from "../../OpeningTimes/OpeningTimeMapper";

export const useUpdatePlantOpeningTime = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (openingTime: OpeningTime) => {
      return axios.put<OpeningTimeDto>(
        openingTimesUrls.openingTimeWithId(openingTime.Id),
        OpeningTimeMapper.toWriteDto(openingTime, openingTime.Id)
      );
    },
    onSuccess: async (_: AxiosResponse<OpeningTimeDto>, variables: OpeningTime) => {
      await queryClient.invalidateQueries(openingTimeWithIdQueryKey(variables.ParentId, "plants"));
      toast.success(updateSuccessMessage(variables.Id, "OpeningTime"));
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
